var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"mainLoader"},[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{staticStyle:{"width":"150px","height":"150px"},attrs:{"type":"grow","variant":"primary"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }